(function () {
  'use strict';

  var PREFERS_REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function HeroCollageSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.prevBtn = root.querySelector('[data-hero-prev]');
    this.nextBtn = root.querySelector('[data-hero-next]');
    this.count = this.slides.length;
    this.index = 0;
    this.timer = null;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !PREFERS_REDUCED_MOTION;
    this.speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;

    if (this.count < 2) return;

    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-hero-dot'), 10);
        this.goTo(i);
        this.restart();
      }.bind(this));
    }, this);

    this.root.addEventListener('keydown', this.onKeydown);
    this.root.addEventListener('mouseenter', this.stop.bind(this));
    this.root.addEventListener('mouseleave', this.restart.bind(this));
    this.root.addEventListener('focusin', this.stop.bind(this));
    this.root.addEventListener('focusout', this.restart.bind(this));
    this.root.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.root.addEventListener('touchend', this.onTouchEnd, { passive: true });

    this.start();
  }

  HeroCollageSlider.prototype.goTo = function (index) {
    if (this.count === 0) return;
    var next = (index + this.count) % this.count;
    if (next === this.index) return;

    var current = this.slides[this.index];
    var upcoming = this.slides[next];

    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    current.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });

    upcoming.classList.add('is-active');
    upcoming.removeAttribute('aria-hidden');
    upcoming.querySelectorAll('a').forEach(function (a) { a.removeAttribute('tabindex'); });

    if (this.dots[this.index]) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[this.index].setAttribute('aria-selected', 'false');
    }
    if (this.dots[next]) {
      this.dots[next].classList.add('is-active');
      this.dots[next].setAttribute('aria-selected', 'true');
    }

    this.index = next;
  };

  HeroCollageSlider.prototype.onPrev = function () {
    this.goTo(this.index - 1);
    this.restart();
  };

  HeroCollageSlider.prototype.onNext = function () {
    this.goTo(this.index + 1);
    this.restart();
  };

  HeroCollageSlider.prototype.onKeydown = function (e) {
    if (e.key === 'ArrowLeft') {
      this.onPrev();
    } else if (e.key === 'ArrowRight') {
      this.onNext();
    }
  };

  HeroCollageSlider.prototype.onTouchStart = function (e) {
    this.touchX = e.changedTouches[0].clientX;
  };

  HeroCollageSlider.prototype.onTouchEnd = function (e) {
    if (typeof this.touchX !== 'number') return;
    var delta = e.changedTouches[0].clientX - this.touchX;
    var threshold = 40;
    if (delta < -threshold) {
      this.onNext();
    } else if (delta > threshold) {
      this.onPrev();
    }
    this.touchX = null;
  };

  HeroCollageSlider.prototype.start = function () {
    if (!this.autoplay || this.count < 2) return;
    this.stop();
    this.timer = window.setInterval(this.onNext.bind(this), this.speed);
  };

  HeroCollageSlider.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  HeroCollageSlider.prototype.restart = function () {
    this.stop();
    this.start();
  };

  HeroCollageSlider.prototype.destroy = function () {
    this.stop();
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
    this.root.removeEventListener('keydown', this.onKeydown);
    this.root.removeEventListener('touchstart', this.onTouchStart);
    this.root.removeEventListener('touchend', this.onTouchEnd);
  };

  var instances = {};

  function initAll(container) {
    var scope = container || document;
    var sliders = scope.querySelectorAll('[data-hero-slider]');
    sliders.forEach(function (el) {
      var sectionEl = el.closest('[id^="shopify-section-"]');
      var id = sectionEl ? sectionEl.id : 'hc-' + Math.random().toString(36).slice(2);
      if (instances[id]) return;
      instances[id] = new HeroCollageSlider(el);
      el.dataset.heroInstanceId = id;
    });
  }

  function destroyIn(container) {
    var sliders = container.querySelectorAll('[data-hero-slider]');
    sliders.forEach(function (el) {
      var id = el.dataset.heroInstanceId;
      if (id && instances[id]) {
        instances[id].destroy();
        delete instances[id];
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slideEl = event.target.closest('[data-hero-slide]');
    if (!slideEl) return;
    var sliderEl = event.target.closest('[data-hero-slider]');
    if (!sliderEl) return;
    var id = sliderEl.dataset.heroInstanceId;
    var instance = id && instances[id];
    var index = parseInt(slideEl.getAttribute('data-slide-index'), 10);
    if (instance && !isNaN(index)) {
      instance.stop();
      instance.goTo(index);
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var sliderEl = event.target.closest('[data-hero-slider]');
    if (!sliderEl) return;
    var id = sliderEl.dataset.heroInstanceId;
    var instance = id && instances[id];
    if (instance) instance.restart();
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll(document);
  }
})();